import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@shared/hooks/use-toast';
import { ManifestListApiAdapter } from '../adapters';

export const useUploadSignedPdf = () => {
  const { t } = useTranslation('manifestsModule');
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ManifestListApiAdapter(httpClient);

  return useMutation({
    mutationFn: ({ manifestId, file }: { manifestId: number; file: File }) =>
      adapter.uploadSignedPdf(manifestId, file),
    onSuccess: () => {
      toast({
        title: t('toast.uploadSuccess', 'PDF subido correctamente'),
        variant: 'default',
      });
    },
    onError: (error: any) => {
      toast({
        title: t('toast.uploadError', 'Error al subir el PDF'),
        description: error?.response?.data?.message || error.message,
        variant: 'destructive',
      });
    },
  });
};
